import { TextHighlightPresentation } from '@lsg/shared';
import { createElement } from 'react';

/* eslint-disable react/require-default-props */
var TextHighlight = function TextHighlight(props) {
  return /*#__PURE__*/createElement(TextHighlightPresentation, Object.assign({}, props));
};
TextHighlight.displayName = "TextHighlight";

export { TextHighlight };
